import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Input,
  PageHeader,
  Form,
  Row,
  Col,
  Popconfirm,
  message,
} from "antd";
import Page from "_components/Page";
import { rackService } from "_services";
import { useLocation, Link } from "react-router-dom";
import TabMenu from "./TabMenu";
import PropTypes from "prop-types";

function Summary({ history, match }) {
  const { id } = match.params;
  const location = useLocation();
  const lastSegment = location.pathname.split("/").pop();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const getById = () => {
    if (match) {
      setIsLoading(true);
      rackService
        .getById(id)
        .then((response) => {
          onFill(response.content);
        })
        .catch((error) => {
          setError(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        rackService
          .update(id, values)
          .then(() => {
            message.success("Successfully updated!");
            history.push("/racks");
          })
          .catch((error) => {
            throw error;
          });
      })
      .catch((error) => {
        setError(`${error.message ?? "Please fix errors"}`);
      })
      .finally(() => {
        setIsLoading(false);
        setError();
      });
  };

  const onCancel = () => {
    history.push("/racks");
  };

  useEffect(() => {
    getById();
  }, []);

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/racks">Racks</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link>
              {lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1)}
            </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={[
        <Popconfirm
          title="Are you sure to add the changes?"
          onConfirm={handleFormSubmit}
          key="add-confirm"
        >
          <Button
            key="1"
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={lastSegment === "summary"}
          >
            Update
          </Button>
        </Popconfirm>,
        <Button key="2" htmlType="button" onClick={onCancel}>
          Cancel
        </Button>,
      ]}
    >
      <Page inner error={error}>
        <TabMenu menu={lastSegment} id={id} />
        <Form
          layout="vertical"
          form={form}
          name="form-create"
          requiredMark={false}
          disabled={lastSegment === "summary"}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name={"code"}
                label="Code"
                rules={[{ required: true, message: "Code is required" }]}
              >
                <Input placeholder="Enter rack code" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name={"name"}
                label="Name"
                rules={[{ required: true, message: "Name is required" }]}
              >
                <Input placeholder="Enter rack name" />
              </Form.Item>
            </Col>
            <Col span={8}></Col>
          </Row>
        </Form>
      </Page>
    </PageHeader>
  );
}

Summary.propTypes = {
  history: PropTypes.isRequired,
  match: PropTypes.isRequired,
};

export default Summary;
